import { BrowserRouter } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { useEffect, useState } from 'react';
import translations from './languages/lv.json';
import { GlobalStyles } from './style';
import { AuthProvider } from './hooks/useAuth';
import { ThemeProvider } from 'providers/ThemeProvider';
import { MessageConfigProvider } from 'providers/MessageConfigProvider';
import { GoogleAnalyticsProvider } from 'providers/GoogleAnalyticsProvider';
import { AppRoutes } from 'routes/AppRoutes';
import MaintenancePage from 'public/pages/MaintenancePage';
import PlausibleAnalytics from 'public/components/DefaultLayout/PlausibleAnalytics';
import MetaPixel from 'public/components/DefaultLayout/MetaPixel';
import { MAINTENANCE_MODE_EVENT } from 'utils/maintenanceMode';

interface MaintenanceModeEventDetail {
  enabled: boolean;
}

export default function App() {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState<boolean>(false);

  useEffect(() => {
    const handleMaintenanceMode = (event: Event) => {
      const { detail } = event as CustomEvent<MaintenanceModeEventDetail>;
      setIsMaintenanceMode(Boolean(detail?.enabled));
    };

    window.addEventListener(
      MAINTENANCE_MODE_EVENT,
      handleMaintenanceMode as EventListener
    );

    return () => {
      window.removeEventListener(
        MAINTENANCE_MODE_EVENT,
        handleMaintenanceMode as EventListener
      );
    };
  }, []);

  return (
    <IntlProvider locale={'lv'} messages={translations}>
      <BrowserRouter>
        <GoogleAnalyticsProvider>
          <ThemeProvider>
            <MessageConfigProvider>
              <PlausibleAnalytics />
              <MetaPixel />
              <GlobalStyles />
              <div id={'app-root'}>
                {isMaintenanceMode ? (
                  <MaintenancePage />
                ) : (
                  <AuthProvider>
                    <AppRoutes />
                  </AuthProvider>
                )}
              </div>
            </MessageConfigProvider>
          </ThemeProvider>
        </GoogleAnalyticsProvider>
      </BrowserRouter>
    </IntlProvider>
  );
}
